<template>
  <div class="binding">
	<div class="tips_box">
		<div class="tips_img">
			<img src="http://yk.ioccn.com/template/default/style/img/img01.png" >
		</div>
		<div class="tips_text">
			<span>{{message}}</span>
		</div>
		<button data-v-bf1681ae="" class="pay" v-on:click="goIndex" style="width: 94vw;">返回首页</button>
		<button data-v-bf1681ae="" class="pay" v-on:click="goApp" style="width: 94vw;background-color:#6ac724">下载APP</button>
	</div>
  </div>
</template>

<script>
  export default {
    name: 'Bindinginfo',
    data () {
      return {
        message:'绑定成功页面'
      }
    },
    mounted () {
      var that=this;
      //绑定
      that.$app.pr('/api/user/binding.html',{
        t:that.$route.query.t,
        idcode:that.$route.query.idcode
      }).then((res) => {
        if (res.success) {
          that.message= res.message;
        }else{
          that.message= res.message;
        }
      }, (res) => {
        console.log(res)
      })
    },
    created(){
    },
    methods: {
		goIndex:function(){
			this.$router.push({path:'/'});
		},
		goApp:function(){
			window.location.href = 'http://yk.ioccn.com/template/default/index/download_tips.html';
		}
    }
  }
</script>

<style>
	@import url("https://yk.ioccn.com/template/default/style/css/tips_style.css");
	.tips_box .tips_text{
		font-size:0.88rem;
		width: 60vw;
		display: block;
		margin: auto;
		line-height: 1.2rem;
	}
	.tips_box .tips_img{
		width:11rem;
		margin-top:3rem;
		max-width:11rem;
	}
	.pay{
		display: block;
		height: 13vw;
		background-color: #5ddfff;
		font-size: 4.3vw;
		bottom: 0px;
		width: 100%;
		text-align: center;
		line-height: 13vw;
		z-index: 100;
		color: #FFFFFF;
		margin-top: 3vw;
		border-radius: 2vw;
		border:0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Bindinginfo.vue